import ReactMarkdown from 'react-markdown';

type MarkdownContentProps = {
  value?: string | null;
  className?: string;
  emptyLabel?: string;
};

export function MarkdownContent({
  value,
  className = '',
  emptyLabel = 'Sem detalhe cadastrado.',
}: MarkdownContentProps) {
  const markdown = value?.trim() ?? '';
  if (!markdown) {
    return <p className={`text-sm text-secondary-500 ${className}`.trim()}>{emptyLabel}</p>;
  }

  return (
    <div className={`markdown-content space-y-2 text-sm text-secondary-800 ${className}`.trim()}>
      <ReactMarkdown
        components={{
          h1: ({ children }) => <h3 className="text-base font-semibold text-secondary-900">{children}</h3>,
          h2: ({ children }) => <h4 className="text-sm font-semibold text-secondary-900">{children}</h4>,
          h3: ({ children }) => <h5 className="text-sm font-semibold text-secondary-900">{children}</h5>,
          p: ({ children }) => <p className="leading-relaxed">{children}</p>,
          ul: ({ children }) => <ul className="list-disc space-y-1 pl-5">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal space-y-1 pl-5">{children}</ol>,
          li: ({ children }) => <li>{children}</li>,
          strong: ({ children }) => <strong className="font-semibold text-secondary-900">{children}</strong>,
          em: ({ children }) => <em>{children}</em>,
          code: ({ children }) => (
            <code className="rounded bg-secondary-100 px-1 py-0.5 font-mono text-xs">{children}</code>
          ),
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noreferrer" className="text-primary-700 underline">
              {children}
            </a>
          ),
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
